/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    exchanges: {
        menu: {
            index: 'صرافی‌ها',
            create: 'جدید',
            list: 'صرافی‌ها'
        },
        table_titles: {
            id: 'شناسه',
            name: 'نام',
            exchange_fee: 'کارمزد صرافی',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش صرافی'
    }
}
